module.exports = __webpack_public_path__ + "static/28-2a19a074444e79d76857c1a38bd99f5a.jpg";